import useMediaQuery from 'usehooks-ts/dist/esm/useMediaQuery/useMediaQuery'

export default function useTabletMediaQuery() {
  return useMediaQuery(`(min-width: ${767}px) and (max-width: ${1023}px) `)
}
